<template>
  <span
    class="flex items-center space-x-1"
    :data-date="params.date"
    :data-start="params.start"
    :data-end="params.end"
    :data-operatory="params.operatory_id"
  >
    <formatter
      :timezone="settings.timezone"
      :value="time"
      class="text-sm"
    ></formatter>
    <span
      v-if="count > 1"
      class="bg-green-400 flex font-bold items-center justify-center leading-none rounded-full circle"
      >{{ count }}</span
    >
  </span>
</template>

<script>
import Formatter from "@/components/Sameday/SamedayTimeFormatter.vue";

export default {
  components: {
    Formatter,
  },
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
    params: {
      type: [Object, Array],
      default: () => {},
    },
  },
  computed: {
    isArray() {
      return Array.isArray(this.params);
    },
    time() {
      return this.isArray ? this.params[0] : this.params;
    },
    count() {
      return this.isArray ? this.params.length : 0;
    },
  },
};
</script>

<style scoped>
.circle {
  font-size: 10px;
  width: 17px;
  height: 17px;
}
</style>
